{
  "notifications": {
    "checkInAtAirport": ""
  },
  "apis": {
    "form": {
      "passport": {
        "scanUploadTitle": "Scan or upload your passport"
      }
    }
  },
  "checkIn": {
    "steps": {
      "apis": {
        "usePassportOnlyNotification": {
          "title": "Using a different form of ID instead of a passport?",
          "content": "Please check in at the airport counter with all the necessary documents.\n\n"
        },
        "infoBox": {
          "ensureDetailsComplete": "Make sure that all details are complete and correct",
          "documentsPreChecked": "Travel documents verified",
          "documentsNotChecked": "",
          "seeAgentOrPreCheck": "Your document will be checked at the airport.",
          "seeAgentOrPreCheckButton": "Verify online and save time"
        }
      }
    }
  },
  "promotion": {
    "goToAirlineCheckIn": {
      "content": "At least one of your flights is operated by another airline. Please check in on their website or at their airport counter.",
      "title": "Check in with the operating airline"
    }
  }
}
